var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.makeupLessons = {
    attach: function (context) {
      var $mlPage = $('.remedies-page', context);
      var $videoCta = $('.js-link--custom-get-the-look', $mlPage);
      var $slides = $('.remedies-page__slider-slide', $mlPage);
      var $carousel = $('.js-remedies-carousel', $mlPage);
      var $showProductsLinks = $('.js-shop-all-products', $mlPage);
      var $carouselContent = $('.remedies-page__content-container', $mlPage);
      var $carouselContentSlides = $('.remedies-page__content-wrap', $carouselContent);
      var $headers = $('.remedies__step-header', $mlPage);
      var slideToShow = window.location.href.split('#')[1];
      var initedCarousel = false;

      // On load hide all the lessons
      $carouselContentSlides.fadeOut();

      // When the video CTA is clicked, we do our custom scroll to the first step
      $videoCta.on('click', function (e) {
        var $activeContentSlide = $('.remedies-page__content-wrap.active', $mlPage);

        $('html, body').animate({
          scrollTop: $('.remedies__step', $activeContentSlide).first().offset().top - 100
        }, 600);
      });
      // We have less than 2 makeup lessons, hide the carousel
      if ($slides.length < 2) {
        $carousel.hide();
      }
      $carousel.slick({
        rtl: site.direction.isRTL,
        slidesToShow: 6,
        slidesToScroll: 1,
        speed: 100,
        draggable: false,
        infinite: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }
        ],
        onInit: function (carousel) {
          if (initedCarousel) {
            return false;
          }
          initedCarousel = true;
          var _slideToShow = slideToShow;

          // We want to start off on a particular slide
          if (_slideToShow) {
            _slideToShow--; // The hash uses 1 as the starting index, so subtract 1 to start from 0
            var slideIndex = parseInt(_slideToShow);

            // If our hash value is a number, go to that makeup lesson slide
            // Use slick-showing to toggle opacity
            if (!isNaN(_slideToShow) && _slideToShow > 0) {
            // Not sure why this is necessary. slickGoTo would not go to the 2nd page if user lands on lesson 6
            // and lesson 6 is on page 2 of carousel
              var slidesPerPage = 3;

              if (Unison.fetch.now().name == 'medium' || Unison.fetch.now().name == 'large') {
                slidesPerPage = 5;
              }
              // How many times do we have to click the next button ?
              // Each click goes forward one slide
              var slickNextCounter = slideIndex - slidesPerPage;

              // Add one because slide 3 is on page 2, so if we want to go to slide 3 on 
              // mobile we want 0 to mean go forward one page
              if (slickNextCounter >= 0) {
                slickNextCounter++;
                for (var i = 0; i < slickNextCounter; i++) {
                // I have no idea why this wouldnt work without the setTimeout
                  setTimeout(function () {
                    $carousel.slickNext();
                  }, 400 * (i + 1));
                }
              }
              // End the manual toggling of slick pages
              $slides.eq(slideIndex).addClass('slick-showing');
              $slides.eq(slideIndex).trigger('click');
              $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
              $carouselContentSlides.eq(slideIndex).stop(true, true).fadeIn().addClass('active');
            } else {
              $slides.eq(0).addClass('slick-showing');
              $carouselContentSlides.eq(0).stop(true, true).fadeIn().addClass('active');
            }
            // Else start from first slide
          } else {
            $slides.eq(0).addClass('slick-showing');
            $carouselContentSlides.eq(0).stop(true, true).fadeIn().addClass('active');
          }
        }
      });

      // Manual changing of slide content
      $('.remedies-page__slide-wrap', $carousel).on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('slick-showing')) {
          return false;
        }
        var $activeSlide = $(this).closest('.remedies-page__slider-slide');

        $slides.not($activeSlide).removeClass('slick-showing');
        $activeSlide.addClass('slick-showing');
        $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
        $carouselContentSlides.eq($activeSlide.index()).stop(true, true).fadeIn().addClass('active');
        $carouselContentSlides.filter('.active').find('.slick-slider').get(0).slick.setPosition();
      });

      // When mobile headers are clicked, do the expanding of the accordion
      // If one is closing, hide the product grid as well
      $headers.on('click', function () {
        var $info = $('.remedies__step-info', $(this).parent());

        $info.stop(true, true).slideToggle().toggleClass('active');
        $info.parent().toggleClass('active');
        if (!$info.parent().hasClass('active')) {
          $('.remedies__step-product-grid', $info.parent()).slideUp();
        }
      });

      // This is the bottom link that sometimes says 'shop all products'
      // Samething as above, once window loads slide up the product grid
      $showProductsLinks.each(function () {
        $(this).parent().find('.remedies-page__shop-all-products__grid').slideUp();
        $(this).on('click', function (e) {
          e.preventDefault();
          $(this).parent().toggleClass('active');
          $(this).parent().find('.remedies-page__shop-all-products__grid').stop(true, true).slideToggle();
          $('.js-product-carousel', $(this).parent())[0].slick.setPosition();
          productGridHeights($(this).parent());
        });
      });

      // Find the product grid, match their heights
      function productGridHeights($elem) {
        $('.product-grid__item', $elem).matchHeight();
      }
    }
  };
})(jQuery);
